import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import PageHeader from './PageHeader';
import './Layout.scss';

export class Layout extends Component {
	static displayName = Layout.name;

	render() {
		return (
			<main>
				<div class="mk-simple-alert-box mk-simple-alert-box-warning">
					<strong>Warning:</strong> This site is deprecated, please use this one instead <a href='https://designflow.daikinapplied.com/design-schedule'>https://designflow.daikinapplied.com/design-schedule</a>
				</div>
				<header className="nav-container">
					<NavMenu />
				</header>
				<section className="main-content">
					<PageHeader />
					{this.props.children}
				</section>
			</main>
		);
	}
}
